import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// Components
import './components'

sync(store, router)

let app = ''

Vue.use(vuetify)

let globalComponent = new Vue({
  data: { $component: '' }
})

Vue.mixin({
  computed: {
    $component: {
      get: function () {
        return globalComponent.$data.$component
      },
      set: function (newComponent) {
        globalComponent.$data.$component = newComponent
      }
    }
  }
})

Vue.config.ignoredElements = [
  'a-scene',
  'a-assets',
  'a-sky'
]

Vue.prototype.$bus = new Vue({})

app = new Vue({
  theme: {
    dark: true
  },
  router,
  store,
  vuetify,
  render: h => h(App)
})
app.$mount('#app')
